import styled from 'styled-components'

export const Actions = styled.div`
  button {
    background-color: #f0f0f0 !important;
    color: #4c4c4c !important;
    border-radius: 8px;
    padding: 0 8px;
    border: none;
    height: 32px;
    font-weight: 700;
    font-size: 14px;
    svg {
      transition: 200ms;
    }
    &:hover {
      svg {
        opacity: 0.7;
      }
    }
  }
`
